<template>
  <div>
    <slot />
  </div>
</template>
<script>
export default {
  mounted() {

    // add listener to detect all clicks
    document.addEventListener("click", this.do);
  },
  methods: {
    do (e) {

      // if click target is contained in the parent element
      if (e.target === this.$el.parentElement || this.$el.parentElement.contains(e.target)) {
        return;
      }

      // emit instruction to perform an action
      this.$emit("do");
      document.removeEventListener("click", this.do);
    }
  }
};
</script>
